<template>
  <el-dialog
    v-if="dialogVisible"
    class="create-cross-node-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    top="20vh"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :label-position="position"
      :rules="editRule"
      :label-width="`${adaptationVars.formLabelWidth}px`"
    >
      <el-form-item label="选择区块链" required>
        <el-form-item prop="chain1Id" style="margin-bottom: 0; flex: 1;">
          <el-select
            v-model="dataForm.chain1Id"
            size="small"
            clearable
            placeholder="请选择区块链"
            @change="handleChainSelect(1)"
          >
            <el-option
              v-for="(item, i) in options"
              :key="item.ChainId + i"
              :label="item.ChainName"
              :value="item.ChainId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <span class="divider-char">~</span>
        <el-form-item prop="chain2Id" style="margin-bottom: 0; flex: 1;">
          <el-select
            v-model="dataForm.chain2Id"
            size="small"
            clearable
            placeholder="请选择区块链"
            @change="handleChainSelect(2)"
          >
            <el-option
              v-for="(item, i) in options"
              :key="item.ChainId + i"
              :label="item.ChainName"
              :value="item.ChainId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form-item>

      <el-form-item label="选择组织" required>
        <el-form-item prop="orgId1" style="margin-bottom: 0; flex: 1;">
          <el-select
            ref="mySelect"
            v-model="dataForm.orgId1"
            placeholder="请选择组织"
            @change="handleSelect(1)"
          >
            <el-option
              v-for="item in orgOptions1"
              :key="item.OrgId"
              :label="item.OrgName"
              :value="item.OrgId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <span class="divider-char">~</span>
        <el-form-item prop="orgId2" style="margin-bottom: 0; flex: 1;">
          <el-select
            ref="mySelect"
            v-model="dataForm.orgId2"
            placeholder="请选择组织"
            @change="handleSelect(2)"
          >
            <el-option
              v-for="item in orgOptions2"
              :key="item.OrgId"
              :label="item.OrgName"
              :value="item.OrgId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form-item>

      <el-form-item label="选择节点" required>
        <el-form-item prop="node1Id" style="margin-bottom: 0; flex: 1;">
          <el-select v-model="dataForm.node1Id" placeholder="请选择节点">
            <el-option
              v-for="item in nodeList1"
              :key="item.NodeId"
              :label="item.NodeName"
              :value="item.NodeId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <span class="divider-char">~</span>
        <el-form-item prop="node2Id" style="margin-bottom: 0; flex: 1;">
          <el-select v-model="dataForm.node2Id" placeholder="请选择节点">
            <el-option
              v-for="item in nodeList2"
              :key="item.NodeId"
              :label="item.NodeName"
              :value="item.NodeId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form-item>

      <el-form-item label="选择用户" required>
        <el-form-item prop="user1Id" style="margin-bottom: 0; flex: 1;">
          <el-select v-model="dataForm.user1Id" placeholder="请选择用户">
            <el-option
              v-for="item in userOptions1"
              :key="item.UserId"
              :label="item.UserName"
              :value="item.UserId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <span class="divider-char">~</span>
        <el-form-item prop="user2Id" style="margin-bottom: 0; flex: 1;">
          <el-select v-model="dataForm.user2Id" placeholder="请选择用户">
            <el-option
              v-for="item in userOptions2"
              :key="item.UserId"
              :label="item.UserName"
              :value="item.UserId"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form-item>

      <el-form-item label="跨链服务IP地址" prop="serverIP">
        <el-input v-model="dataForm.serverIP"></el-input>
      </el-form-item>

      <el-form-item label="跨链服务端口" prop="serverPort">
        <el-input v-model="dataForm.serverPort"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleCreateCrossChain()">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'CreateCrossNode',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 120
  },
  data() {
    return {
      disabled: false,
      dialogVisible: false,
      orgOptions1: [], //组织
      orgOptions2: [], //组织

      userOptions1: [], //用户列表
      userOptions2: [], //用户列表

      nodeList1: [], //节点列表
      nodeList2: [], //节点列表

      orgId1: '',
      orgId2: '',

      title: '新建跨链服务',
      position: 'right',
      crosschainId: '',
      dataForm: {
        node1Id: '',
        node2Id: '',
        user1Id: null,
        user2Id: null,
        orgId1: '',
        orgId2: '',
        serverIP: '',
        serverPort: null,
        sp2pPort: null,
        chain1Id: '',
        chain2Id: ''
      },
      editRule: {
        chain1Id: [{ required: true, message: '请选择区块链', trigger: 'change' }],
        chain2Id: [{ required: true, message: '请选择区块链', trigger: 'change' }],
        orgId1: [{ required: true, message: '请选择组织', trigger: 'change' }],
        orgId2: [{ required: true, message: '请选择组织', trigger: 'change' }],
        node1Id: [{ required: true, message: '请选择节点', trigger: 'change' }],
        node2Id: [{ required: true, message: '请选择节点', trigger: 'change' }],
        user1Id: [{ required: true, message: '请选择用户', trigger: 'change' }],
        user2Id: [{ required: true, message: '请选择用户', trigger: 'change' }],
        serverIP: [{ required: true, message: '请输入', trigger: 'blur' }],
        serverPort: [
          { required: true, message: '请输入', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'blur' }
        ],
        sp2pPort: [
          { required: true, message: '请输入', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'blur' }
        ]
      },
      adaptationVars: {
        formLabelWidth: 120
      }
    }
  },
  mounted() {
    this.getOptions()
    // this.getOrgOption()
    // 获取当前选中值s
  },
  methods: {
    //创建跨链节点
    handleCreateCrossChain() {
      let self = this
      this.$refs.dataForm.validate(async valid => {
        if (valid) {
          self.disabled = true
          //获取form数据
          self.dataForm.serverPort = Number(self.dataForm.serverPort)
          self.dataForm.sp2pPort = Number(self.dataForm.sp2pPort)
          self.$apis.crossChain
            .createCrossChain(self.dataForm)
            .then(res => {
              if (res) {
                self.$message.success('新建跨链服务成功')
                self.crosschainId = res.data.crosschainId
                self.$emit('update:list')
                self.$emit('showDownload', { id: res.data.crosschainId }, true)

                self.dialogVisible = false
                self.disabled = false
              } else {
                self.$message.error(err)
                self.disabled = false
              }
            })
            .catch(err => {
              // this.$message.error(err)
              self.disabled = false
            })
        } else {
          self.$message.warning('请完善信息')
          self.disabled = false
          return
        }
      })
    },
    getOptions() {
      let param = {
        offset: 0,
        limit: 50
      }
      this.$apis.home.getSubscribeQueryList(param).then(res => {
        if (res.data && res.data.items) {
          this.options = res.data.items
          let storeId = sessionStorage.getItem('cbaas_chain_id')
          let storeItem = this.options.filter(ele => ele.ChainId === storeId)
          let id = storeItem.length > 0 ? storeId : this.options[0]?.ChainId
          this.value = id
          this.$store.commit('updateChainCid', id)
          sessionStorage.setItem('cbaas_chain_id', id)
        }
        if (res.data && res.data.items.length === 0) {
          this.$store.commit('updateLoading', false)
          this.$message.warning('请订阅区块链！')
        }
      })
    },
    handleChainSelect(type) {
      this.getOrgOption(type)
    },

    //获取组织
    getOrgOption(type) {
      let param = {
        offset: 0,
        limit: 100
      }
      if (type == 1) {
        this.orgOptions1 = []
        param.chainId = this.dataForm.chain1Id
      } else {
        this.orgOptions2 = []
        param.chainId = this.dataForm.chain2Id
      }
      this.$apis.chain.getChainOrgList(param).then(res => {
        if (res.data.items) {
          if (type == 1) {
            this.orgOptions1 = res.data.items
          } else {
            this.orgOptions2 = res.data.items
          }
        }
      })
    },
    handleSelect(type) {
      this.handleGetUserList(type)
      this.handleGetNodeList(type)
    },
    //获取用户列表
    handleGetUserList(type) {
      let OrgId = ''
      if (type == 1) {
        this.userOptions1 = []
        OrgId = this.dataForm.orgId1
      } else {
        this.userOptions2 = []
        OrgId = this.dataForm.orgId2
      }

      this.$apis.certificate.getUserListByOrg({ OrgId }).then(res => {
        if (res.data && res.data.items) {
          type == 1 ? (this.userOptions1 = res.data.items) : (this.userOptions2 = res.data.items)
        }
      })
    },
    //获取节点列表
    handleGetNodeList(type) {
      let param = {
        offset: 0,
        limit: 1000
      }
      if (type == 1) {
        this.nodeList1 = []
        param.chainId = this.dataForm.chain1Id
        param.orgId = this.dataForm.orgId1
      } else {
        this.nodeList2 = []
        param.chainId = this.dataForm.chain2Id
        param.orgId = this.dataForm.orgId2
      }

      this.$apis.chain.queryChainOrgNode(param).then(res => {
        if (res) {
          type == 1 ? (this.nodeList1 = res.data.items) : (this.nodeList2 = res.data.items)
        }
      })
    },
    handleCancel() {
      this.dialogVisible = false
      this.disabled = false
    },
    handleOpen(chainId) {
      this.dataForm = {
        serverIP: '',
        serverPort: null,
        sp2pPort: null,
        chainId: ''
      }
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
.create-cross-node-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);

    .el-select {
      width: 100%;
    }

    .divider-char {
      padding: 0 var(--base-size-4);
    }

    /deep/ .el-form-item__content {
      display: flex;
    }
  }
}
</style>
